import {
  Component,
  Input,
  OnInit
} from '@angular/core';


@Component({
  selector: 'app-login-error',
  templateUrl: './login-error.component.html',
  styleUrls: ['./login-error.component.css']
})
export class LoginErrorComponent implements OnInit {

  @Input()
errorData: any = {
  ok: false,
  message: '',
  url: '',
  cusName: ''
};


  constructor() { }


  ngOnInit(): void { }


  // =========================================================
  // ¿EL ERROR VIENE CON URL?
  // =========================================================

  get hasRedirectUrl(): boolean {

    return !!(
      this.errorData &&
      this.errorData.url &&
      this.errorData.url
        .toString()
        .trim()
    );

  }


  // =========================================================
  // URL
  // =========================================================

  get redirectUrl(): string {

    if (!this.hasRedirectUrl) {
      return '';
    }


    return this.normalizeUrl(
      this.errorData.url
    );

  }


  // =========================================================
  // URL PARA MOSTRAR
  // =========================================================

  get displayUrl(): string {

    if (!this.redirectUrl) {
      return '';
    }


    return this.redirectUrl
      .replace(
        /^https?:\/\//i,
        ''
      )
      .replace(
        /\/$/,
        ''
      );

  }


  // =========================================================
  // NOMBRE CLIENTE DESDE URL
  //
  // https://chubb.almamedis.cl
  //           ↓
  //         Chubb
  // =========================================================

  get customerName(): string {

  const cusName =
    this.errorData?.cusName
      ?.toString()
      .trim();

  if (cusName) {
    return cusName;
  }

  return 'esta institución';
}


  // =========================================================
  // REDIRECCIÓN
  // =========================================================

  redirectToUrl(): void {

    if (!this.redirectUrl) {
      return;
    }


    /*
     * Redirige EXACTAMENTE a la URL
     * entregada por backend.
     *
     * Ej:
     * https://chubb.almamedis.cl
     */
    window.location.href =
      this.redirectUrl;

  }


  // =========================================================
  // NORMALIZAR URL
  // =========================================================

  private normalizeUrl(
    value: any
  ): string {

    const url =
      (
        value || ''
      )
        .toString()
        .trim();


    if (!url) {
      return '';
    }


    if (
      /^https?:\/\//i.test(
        url
      )
    ) {

      return url;

    }


    return `https://${url}`;

  }

}